import React from 'react';

export default () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <path d='M12.347 5.375a.291.291 0 0 1 .29.318l-.75 8.246A1.167 1.167 0 0 1 10.727 15H5.273c-.603 0-1.107-.46-1.161-1.061L3.36 5.693a.292.292 0 0 1 .291-.318zM6.543 7.271a.438.438 0 0 0-.438.437v5.25a.437.437 0 1 0 .875 0v-5.25a.438.438 0 0 0-.437-.437zm2.917 0a.438.438 0 0 0-.438.437v5.25a.437.437 0 1 0 .875 0v-5.25a.438.438 0 0 0-.438-.437zM9.457 1c.806 0 1.459.653 1.459 1.458v.73c0 .08.065.145.146.145h2.77a.583.583 0 1 1 0 1.167H2.167a.583.583 0 1 1 0-1.167h2.77a.146.146 0 0 0 .146-.146v-.729C5.083 1.653 5.736 1 6.542 1zm0 1.167H6.542a.292.292 0 0 0-.292.291v.73c0 .08.065.145.146.145h3.208c.08 0 .146-.065.146-.146v-.729a.292.292 0 0 0-.292-.291z' />
  </svg>
);
